import FeaturedItemsBlock from './featuredItemsBlock'

export default FeaturedItemsBlock
